import * as React from 'react';
import { useJsonForms } from '@jsonforms/react';

/**
 * Shape of the returned error information for an array (and its items)
 */
export interface JsonFormsPathErrorsResult {
  arrayItemHasError: (index: number) => boolean;
}

const toInstancePath = (path: string): string =>
  `/${path.split('.').filter(Boolean).join('/')}`;

/**
 * Hook to check if there are specific validation errors, Currently only supports checking array items.
 * Returns an object with arrayItemHasError function for checking specific array items.
 */
export const useJsonFormsErrorsForPath = (
  path: string | undefined,
): JsonFormsPathErrorsResult => {
  const ctx = useJsonForms();

  return React.useMemo(() => {
    const errors = ctx.core?.errors || [];

    if (!path) {
      return {
        arrayItemHasError: () => false,
      };
    }

    const instancePath = toInstancePath(path);

    const arrayItemHasError = (index: number) => {
      const itemPrefix = `${instancePath}/${index}`;
      const itemPrefixSlash = `${itemPrefix}/`;
      return errors.some(
        (e) =>
          e.instancePath === itemPrefix ||
          e.instancePath.startsWith(itemPrefixSlash),
      );
    };

    return {
      arrayItemHasError,
    };
  }, [ctx.core?.errors, path]);
};
